<script>
  import {getContext, onMount} from 'svelte';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const doms = [];
  const contentDoms = [];
  const widths = [];
  const height = 54;
  const marginBottom = 4;
  const LG = getContext('LG');
  const kols = [
    {
      icon: IMAGES.KOL_ICON_1,
      content: LG(lang.KOL_Message1),
    },
    {
      icon: IMAGES.KOL_ICON_2,
      content: LG(lang.KOL_Message2),
    },
    {
      icon: IMAGES.KOL_ICON_3,
      content: LG(lang.KOL_Message3),
    },
    {
      icon: IMAGES.KOL_ICON_4,
      content: LG(lang.KOL_Message4),
    },
    {
      icon: IMAGES.KOL_ICON_1,
      content: LG(lang.KOL_Message1),
    },
    {
      icon: IMAGES.KOL_ICON_2,
      content: LG(lang.KOL_Message2),
    },
    {
      icon: IMAGES.KOL_ICON_3,
      content: LG(lang.KOL_Message3),
    },
    {
      icon: IMAGES.KOL_ICON_4,
      content: LG(lang.KOL_Message4),
    },
  ];

  let stop = false;
  let activeIndex = -1;
  let tops = [];
  let timeout;
  let show = false;

  onMount(() => {
    doms.forEach((dom, i) => {
      tops.push(dom.offsetTop);
      widths.push(contentDoms[i].scrollWidth);
    });
    tops.forEach((top, i) => {
      Object.assign(doms[i].style, {
        top: top + 'px',
        position: 'absolute',
      });
    });
    contentDoms.forEach((dom) => {
      dom.style.width = 0;
    });
    show = true;
    start();
  });

  function start() {
    stop = false;
    run();
  }

  function run() {
    clearTimeout(timeout);
    tops = tops.map((top, i) => {
      let val = top - 1;
      if (val === -height) {
        if (i === 0) {
          return tops[tops.length - 1] + marginBottom + height;
        }
        return tops[i - 1] + marginBottom + height;
      }
      return val;
    });
    doms.forEach((dom, i) => {
      dom.style.top = `${tops[i]}px`;
    });
    if (stop) {
      return;
    }
    timeout = setTimeout(run, 20);
  }

  function handleMouseOverFun(index) {
    return function () {
      activeIndex = index;
      contentDoms[index].style.width = widths[index] + 'px';
      stop = true;
    };
  }

  function handleMouseOut() {
    activeIndex = -1;
    start();
    contentDoms.forEach((dom) => {
      dom.style.width = 0;
    });
  }
</script>

<style>
  .kol-marquee {
    position: absolute;
    right: calc(var(--aspect-ratio) * 32px);
    bottom: calc(var(--aspect-ratio) * 72px);
    padding-left: 20px;
    width: max(calc(var(--aspect-ratio) * 360px), 320px);
    height: 220px;
    visibility: hidden;
    overflow-y: hidden;
  }
  .kol-marquee.show {
    visibility: visible;
  }
  .kols {
    position: relative;
  }
  .kol.active {
    background: #f6f7fb;
  }
  .kol {
    right: 0;
    margin-bottom: 4px;
    box-sizing: border-box;
    border-radius: 32px;
    padding: 12px 20px;
    cursor: pointer;
  }
  .icon {
    margin-left: 8px;
    border-radius: 20px;
    width: 38px;
    height: 38px;
  }
  .content {
    display: flex;
    align-items: center;
    height: 38px;
    line-height: 19px;
    font-size: 12px;
    color: #898989;
    overflow: hidden;
    transition: width 0.2s;
  }
  .mask {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
    width: 80px;
    height: 36px;
    background: linear-gradient(to top, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }
  .mask.bottom {
    top: auto;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }
  @media screen and (max-width: 640px) {
    .kol-marquee {
      display: none;
    }
  }
</style>

<div class="kol-marquee" class:show>
  <div class="mask" />
  <div class="mask bottom" />
  <div class="kols">
    {#each kols as kol, i}
      <div class="kol df aic" class:active={activeIndex === i} on:mouseover={handleMouseOverFun(i)} on:mouseout={handleMouseOut} bind:this={doms[i]}>
        <div class="content" bind:this={contentDoms[i]}>{kol.content}</div>
        <img class="icon" height="38" src={kol.icon} />
      </div>
    {/each}
  </div>
</div>
